exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#paymentCollectionTotals {\n  text-align: right;\n  padding-right: 10px; }\n  #paymentCollectionTotals .ui.header {\n    display: inline-block;\n    margin-right: 8px; }\n  #paymentCollectionTotals .total-value {\n    min-width: 70px;\n    display: inline-block;\n    font-weight: bold; }\n\n#paymentRoot {\n  padding: 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Payments/PaymentCollection/paymentCollection.scss
// module id = 1476
// module chunks = 1